export const emis = [
  {
    title: "A. EMIS PD-PONTREN",
    description: "Aplikasi EMIS PD PONTREN",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/emis-wajib.png?raw=true",
    link: "http://emispendis.kemenag.go.id/pdpontrenv2/Login",
    deadline: "",
  },
  {
    title: "B. Pendaftaran dan pergantian Operator EMIS",
    description: `Bagi lembaga yang belum daftar Operator EMIS, daftar lebih dulu dengan klik kotak ini`,
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/operator-emis.png?raw=true",
    link: "https://bit.ly/Pendaftaran_Operator_EMIS_September_2021",
    deadline: "",
  },
  {
    title: "C. EMIS Khusus Ma'had Aly",
    description: `Link aplikasi EMIS khusus Ma'had Aly`,
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/mahad-aly.jpeg?raw=true",
    link: "http://emispendis.kemenag.go.id/mahadaly/login",
    deadline: "",
  },
  {
    title: "D. EMIS PD-PONTREN Versi 4",
    description: "Aplikasi EMIS PD PONTREN Versi 4. Untuk satuan pendidikan (SPM, PDF, dan PK-PPS)",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/emis-wajib.png?raw=true",
    link: "https://emis.kemenag.go.id/",
    deadline: "",
  },
];

export const bantuan = [
  {
    title: "A. Simba PD Pontren",
    description:
      "Sistem Informasi Manajemen Bantuan Pendidikan Diniyah Dan Pondok Pesantren",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/simba-pontren.png?raw=true",
    link: "https://simba.kemenag.go.id/",
    deadline: "",
  },
  {
    title: "B. SIKAP (Sistem Informasi Ketenagaan Pesantren)",
    description: "Aplikasi tentang Sistem Informasi Ketenagaan Pesantren",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/sikap-pontren.png?raw=true",
    link: "https://sikap.kemenag.go.id/",
    deadline: "",
  },
];

export const permohonanIzin = [
  {
    title: "A. SITREN",
    description: "Aplikasi sistem informasi tanda keberadaan pesantren",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/sitren-pontren.png?raw=true",
    link: "https://sitren.kemenag.go.id/",
    deadline: "",
  },
  {
    title: "B. SIPDAR-PQ",
    description:
      "Aplikasi sistem informasi pelayanan tanda daftar lembaga pendidikan Al-Quran",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/sipdar-pq.png?raw=true",
    link: "https://sipdarlpq.kemenag.go.id",
    deadline: "",
  },
  {
    title:
      "C. Pendidikan Ma'had Aly, Pendidikan Diniyah Formal (PDF), Satuan Pendidikan Muadalah (SPM)",
    description:
      "Aplikasi Ijin operasional Pendidikan Ma'had Aly, Pendidikan Diniyah Formal (PDF), Satuan Pendidikan Muadalah (SPM)",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/ijop-pdma.jpeg?raw=true",
    link: "https://ijoppdma.kemenag.go.id/",
    deadline: "",
  },
];
